import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MetadataComponent} from '@components/administration/metadata/metadata.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MetadataEditComponent} from '@components/administration/metadata/modals/metadata-edit.component';
import {SharedModule} from '@shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {
  NgbDropdown,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbHighlight
} from '@ng-bootstrap/ng-bootstrap';
import {MetadataActionComponent} from '@components/administration/metadata/metadata-action/metadata-action.component';
import {NgSelectModule} from '@ng-select/ng-select';


@NgModule({
  declarations: [
    MetadataComponent,
    MetadataEditComponent,
    MetadataActionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    NgbHighlight,
    ReactiveFormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgbDropdownItem,
    NgbDropdownToggle,
    NgbDropdown,
    NgbDropdownMenu,
  ],
  exports: [
    MetadataComponent
  ]
})
export class MetadataModule {
}
